import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../../config/api-urls/api-urls';
import { MainService } from '../../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-add-faq',
  templateUrl: './add-faq.component.html',
  styleUrls: ['./add-faq.component.css']
})
export class AfaqComponent implements OnInit {
  
  form: FormGroup | any;
  constructor(private router: Router, public mainService: MainService) { }

  ngOnInit() {
    this.form = new FormGroup({
      "question": new FormControl('', Validators.required),
      "answer": new FormControl('', Validators.required),
    });
  }

  addFaq() {
    const data = {
      question: this.form.value.question,
      answer: this.form.value.answer,

    }
    this.mainService.postApi(ApiUrls.addFaq, data, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.mainService.successToast(res.responseMessage);
        this.router.navigate(['faq-mgt'])

      }
      else {
        this.mainService.errorToast(res.responseMessage);

      }
    }, err => {
      this.mainService.errorToast(err.responseMessage);
    })
  }

}
